export enum UnitOfMeasurement {
  Kg = 'кг',
  Ton = 'т'
}
